import {
  Button,
  Center,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from '@chakra-ui/react'
import { CloseIcon, Icon } from '@chakra-ui/icons'
import { IoCloseCircle } from 'react-icons/io5'
import * as yup from 'yup'
import { string } from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import { useUpdateCurrentUser } from '../../../api/user/User.api'
import { createStandaloneToast } from '@chakra-ui/toast'
import { MdCheckCircle } from 'react-icons/md'

type UsernameInputTypes = {
  firstName: string
  lastName: string
}
const EditUsernameBottomSheet = () => {
  const { firstName, lastName, onClose } = useSelector(
    (state: RootState): { firstName: string; lastName: string; onClose: () => void } =>
      state.bottomSheet.data,
  )
  const editUsernameSchema = yup.object().shape({
    firstName: string().required('لطفا نام را وارد کنید'),
    lastName: string().required('لطفا نام خانوادگی را وارد کنید'),
  })
  const { toast } = createStandaloneToast()

  const editUserDetails = useUpdateCurrentUser({
    onSuccess: () => {
      toast({
        title: 'نام و نام خانوادگی با موفقیت تغییر کرد.',
        position: 'top',
        status: 'success',
        variant: 'actionSuccess',
        icon: (
          <Center>
            <Icon size='16px' as={MdCheckCircle} color='success.icon' />
          </Center>
        ),
      })
      onClose()
    },
  })

  const { register, setValue, watch, handleSubmit } = useForm<UsernameInputTypes>({
    resolver: yupResolver(editUsernameSchema),
    mode: 'all',
    defaultValues: {
      firstName: firstName,
      lastName: lastName,
    },
  })

  function onSubmit(data: UsernameInputTypes) {
    editUserDetails.mutate({
      first_name: data.firstName,
      last_name: data.lastName,
    })
  }

  return (
    <DrawerContent borderTopRadius='8px' pt='24px' pb='0!' px='16px'>
      <DrawerHeader p='0!' justifyContent='space-between' w='full' display='flex' flexDir='row'>
        <Text textStyle='titleXSmall' fontWeight='bold' textColor='text.grey-800'>
          {!firstName || !lastName ? 'وارد کردن' : 'ویرایش'} نام و نام خانوادگی
        </Text>
        <Center>
          <CloseIcon onClick={onClose} color='' boxSize='4' />
        </Center>
      </DrawerHeader>
      <DrawerBody pt='12px' pb='24px' px='0px' w='full'>
        <form id='username-edit-form' onSubmit={handleSubmit(onSubmit)}>
          <FormControl variant='floating-icon' id='karnameh-app-firs-name' mt='24px'>
            <InputGroup>
              <Input
                required={false}
                type='text'
                py='10px!'
                px='16px'
                outline='0px'
                border='1px'
                _focusVisible={{
                  border: 'none',
                }}
                borderColor={!watch('firstName') ? 'error.icon' : 'text.deactive'}
                _focus={{
                  outline: 'none',
                  border: '1px solid',
                  borderColor: !watch('firstName') ? 'error.icon' : 'accent.main',
                }}
                _placeholder={{
                  fontWeight: '400',
                  fontSize: '16px',
                  lineHeight: '32px',
                  color: 'text.primary',
                }}
                {...register('firstName')}
              />
              <InputRightElement onClick={() => setValue('firstName', '')}>
                <Icon boxSize='24px' as={IoCloseCircle} color='text.deactive' />
              </InputRightElement>
            </InputGroup>

            {/* It is important that the Label comes after the Control due to css selectors */}
            <FormLabel
              _focus={{
                textColor: 'accent.enable',
              }}
              backgroundColor='white'
            >
              نام
            </FormLabel>
          </FormControl>
          <FormControl variant='floating-icon' id='karnameh-app-firs-name' mt='24px'>
            <InputGroup>
              <Input
                required={false}
                type='text'
                py='10px!'
                px='16px'
                outline='none'
                border='1px'
                _focusVisible={{
                  border: 'none',
                }}
                borderColor={!watch('lastName') ? 'error.icon' : 'text.deactive'}
                _focus={{
                  outline: 'none',
                  border: '1px solid',
                  borderColor: !watch('lastName') ? 'error.icon' : 'accent.main',
                }}
                _placeholder={{
                  fontWeight: '400',
                  fontSize: '16px',
                  lineHeight: '32px',
                  color: 'text.primary',
                }}
                errorBorderColor='error.divider-border'
                {...register('lastName')}
              />
              <InputRightElement onClick={() => setValue('lastName', '')}>
                <Icon boxSize='24px' as={IoCloseCircle} color='text.deactive' />
              </InputRightElement>
            </InputGroup>

            {/* It is important that the Label comes after the Control due to css selectors */}
            <FormLabel
              _focus={{
                textColor: 'accent.enable',
              }}
              textStyle='captionLargeRegular'
              textColor='text.deactive'
              backgroundColor='white'
            >
              نام خانوادگی
            </FormLabel>
          </FormControl>
        </form>
      </DrawerBody>
      <DrawerFooter pb='24px' px='0!' w='full'>
        <Button
          bg='illustration.brandgreen'
          fontSize='18px'
          lineHeight='36px'
          _hover={{
            bg: 'illustration.brandgreen',
          }}
          _disabled={{
            bg: 'primary.deactive',
          }}
          h='48px'
          form='username-edit-form'
          type='submit'
          w='full'
        >
          ثبت
        </Button>
      </DrawerFooter>
    </DrawerContent>
  )
}
export default EditUsernameBottomSheet
